#import "./confluence-comment-fragment.graphql"

mutation CreateInlineComment($input: CreateInlineCommentInput!) {
  createInlineComment(input: $input) {
    ...CommentFragment
    replies {
      ...CommentFragment
    }
  }
}
